export const SET_VALUE_ANSWERS = '@fmc/surveys/SET_VALUE_ANSWERS';
export const CLEAN_VALUE_ANSWERS = '@fmc/surveys/CLEAN_VALUE_ANSWERS';
export const FETCH_SURVEYS_ACTION = '@fmc/surveys/FETCH_SURVEYS_ACTION';
export const FETCH_SURVEYS_SUCCESS = '@fmc/surveys/FETCH_SURVEYS_SUCCESS';
export const FETCH_SURVEYS_FAILURE = '@fmc/surveys/FETCH_SURVEYS_FAILURE';
